import { frontendParams } from '../config/frontend'

export default {
  data() {
    return {
      constantCompanyOffers: [
        {
          componentName: 'certified-experts-svg',
          name: 'Minősített szakértők',
          link: 'https://vali.ifka.hu/hu/experts'
        },
        {
          componentName: 'modern-factories-svg',
          name: 'Modern mintaüzemek',
          link: 'https://modem4.hu/'
        },
        {
          componentName: 'school-svg',
          name: 'Általános képzések',
          link: `${frontendParams.url}/courses`
        },
        {
          componentName: 'consultancy-svg',
          name: 'Pályázati tanácsadás',
          link: `${frontendParams.url}/szechenyi-programiroda`
        }
      ]
    }
  }
}
